export const DEFAULT_KROKI_BASE_URL = '';

/**
 * Resolve the Kroki base URL from validated environment variables.
 * If unset, returns an empty string so callers can skip diagram generation.
 */
export function getKrokiBaseUrlFromEnv(): string {
  try {
    // Lazy import to avoid hard coupling in browser bundles.
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { getEnv } = require('./CoreEnvironmentService') as {
      getEnv: () => { KROKI_BASE_URL?: string };
    };
    const env = getEnv();
    const raw = env?.KROKI_BASE_URL;
    if (typeof raw === 'string' && raw.trim().length > 0) {
      return trimTrailingSlashes(raw.trim());
    }
  } catch {
    // Swallow errors when env is unavailable (e.g., during client bundling).
  }
  return DEFAULT_KROKI_BASE_URL;
}

function trimTrailingSlashes(value: string): string {
  return value.replace(/\/+$/, '');
}
